import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const HomeDentacare = () => {
  const [DentacareTopUser, setDentacareTopUser] = useState([]);
  const [DentacareImageUser, setDentacareImageUser] = useState([]);
  const [DentacareUser, setDentacareUser] = useState([]);
  const navigate = useNavigate();

  //   Dentacare top api
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://admin.gosaviadvanceddentalclinic.com/api/getdentacaretop"
      );
      setDentacareTopUser(response.data);
    };

    fetchData();
  }, []);

  //   Dentacare image api
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://admin.gosaviadvanceddentalclinic.com/api/getdentacareimage"
      );
      setDentacareImageUser(response.data);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://admin.gosaviadvanceddentalclinic.com/api/getdentacare"
      );
      setDentacareUser(response.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`https://admin.gosaviadvanceddentalclinic.com/api/deletedentacare/${userId}`);

      setDentacareUser((prevUsers) =>
        prevUsers.filter((user) => user.id !== userId)
      );

      toast.error("Data Deleted Successfully!");
      navigate("/Dentacare");
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete data!");
    }
  };

  return (
    <div className="container homeBanner-details">
      <div className="row arpi">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>

        <div className="col-lg-10 col-md-10 col-sm-12 view-home">
          {DentacareImageUser.map((user) => {
            return (
              <div>
                <img
                  src={user.dentacareimage}
                  alt="Dentacare"
                  style={{ width: "450px", height: "300px" }}
                />{" "}
                <Link to={`/Dentacare-image-edit/` + user.id}>
                  {" "}
                  <i className="fa-regular fa-pen-to-square imageedit-btn"></i>
                </Link>
              </div>
            );
          })}
<br/>
          {DentacareTopUser.map((user) => {
            return (
              <div>
                <h3>
                  {user.heading}{" "}
                  <Link to={`/Dentacare-header-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-btn"></i>
                  </Link>
                </h3>
                <p dangerouslySetInnerHTML={{ __html: user.description }}></p>
              </div>
            );
          })}
          <Link to="/Dentacare-add">
            <button className="Banner-button">Add</button>
          </Link>
          <div className="row table-home">
            <table>
              <thead>
                <tr>
                  <th className="col-lg-1">Sr.No</th>
                  <th className="col-lg-2">Title</th>
                  <th className="col-lg-4">Paragraph</th>
                  <th className="col-lg-1">Action</th>
                </tr>
              </thead>
              <tbody>
                {DentacareUser.map((user, index) => {
                  return (
                    <tr key={user.id}>
                      <td>{index + 1}</td>
                      <td>{user.title}</td>
                      <td>
                        <p dangerouslySetInnerHTML={{ __html: user.para }}></p>
                      </td>
                      <td>
                        <Link to={`/Dentacare-edit/` + user.id}>
                          <i className="fa-regular fa-pen-to-square action-btn"></i>
                        </Link>
                        <span onClick={() => deleteUser(user.id)}>
                          <i
                            title="Delete"
                            className="fa-solid fa-trash-can action-btn"
                            style={{ color: "red" }}
                          ></i>
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export const DentacareAdd = () => {
  const [DentacareData, setDentacareData] = useState({
    title: "",
    para: "",
  });

  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setDentacareData((prev) => ({ ...prev, [name]: value }));
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://admin.gosaviadvanceddentalclinic.com/api/createdentacare",
        DentacareData
      );
      toast.success("Data added successfully!");
      navigate("/Dentacare");
    } catch (error) {
      console.error("Error adding Dentacare:", error);
      toast.error("Failed to add Dentacare!");
    }
  };

  return (
    <div className="container add-page">
      <div className="row">
        <div className="col-lg-2 col-md-2 col-sm-12" />
        <div className="col-lg-10 col-md-10 col-sm-12 add-details">
          <div className="add-banner">
            <Link to="/Dentacare">
              <i className="fa-solid fa-xmark"></i>
            </Link>
            <h3>Add Dentacare Data</h3>
            <form
              className="row"
              onSubmit={submitForm}
              encType="multipart/form-data"
            >
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="title">Title</label>
                <input
                  type="text"
                  onChange={inputHandler}
                  value={DentacareData.title}
                  id="title"
                  name="title"
                  placeholder="Enter Title"
                />
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="para">Paragraph</label>
                <textarea
                  onChange={inputHandler}
                  value={DentacareData.para}
                  id="para"
                  name="para"
                  placeholder="Enter Paragraph"
                  rows="4"
                ></textarea>
              </div>
              <div className="mobilesubmitform">
                <button type="submit">Add Data</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export const DentacareEdit = () => {
  const [Dentacareuser, setDentacareUser] = useState({
    title: "",
    para: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();
   const [editorLoaded, setEditorLoaded] = useState(false);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setDentacareUser({ ...Dentacareuser, [name]: value });
    // console.log(user);
  };

   // ✅ Load CKEditor script dynamically
    useEffect(() => {
      const script = document.createElement("script");
      script.src = "https://cdn.ckeditor.com/4.21.0/standard/ckeditor.js";
      script.async = true;
      script.onload = () => setEditorLoaded(true);
      document.body.appendChild(script);
  
      return () => {
        if (window.CKEDITOR) {
          Object.keys(window.CKEDITOR.instances).forEach((instance) => {
            window.CKEDITOR.instances[instance].destroy(true);
          });
        }
      };
    }, []);

      // ✅ Fetch Dentacare data
      const fetchDentacareData = async () => {
        try {
          const response = await axios.get(
            `https://admin.gosaviadvanceddentalclinic.com/api/getonedentacare/${id}`
          );
          if (response.data.success) {
            setDentacareUser(response.data.data);
    
            if (window.CKEDITOR && window.CKEDITOR.instances.editor) {
              window.CKEDITOR.instances.editor.setData(
                response.data.data.para
              );
            }
          }
        } catch (error) {
          console.error("Error fetching Dentacare data!", error);
          toast.error("Failed to load Dentacare data.");
        }
      };

       useEffect(() => {
          if (editorLoaded) {
            fetchDentacareData();
          }
        }, [id, editorLoaded]);
      
        useEffect(() => {
          if (editorLoaded && !window.CKEDITOR.instances.editor) {
            window.CKEDITOR.replace("editor");
          }
        }, [editorLoaded]);
      
        useEffect(() => {
          if (editorLoaded && window.CKEDITOR.instances.editor) {
            window.CKEDITOR.instances.editor.setData(Dentacareuser.para || "");
          }
        }, [Dentacareuser.para, editorLoaded]);
      

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = {
      title: Dentacareuser.title,
      para: window.CKEDITOR.instances.editor.getData(),
    };

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updatedentacare/${id}`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.data.success) {
        setDentacareUser(formData);
        toast.success("Data updated successfully!");
        navigate("/Dentacare");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="exampleModalLabel"
      style={{
        display: "block",
        paddingRight: 18,
        marginTop: 90,
        paddingBottom: 50,
      }}
      aria-modal="true"
    >
      <div className="modal-dialog" role="document">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit
              </h5>
              <Link to="/Dentacare">
                <button type="button" className="close" aria-label="Close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Title</label>
                <input
                  type="text"
                  value={Dentacareuser.title}
                  onChange={changeHandler}
                  className="form-control"
                  name="title"
                />
                <br />
              </div>

              <div className="form-group">
                <label>Paragraph</label>
                <textarea id="editor"></textarea>
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/Dentacare">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export const HomeDentacareImageEdit = () => {
  const [Dentacareuser, setDentacareUser] = useState({
    dentacareimage: "",
  });
  const [previewImage, setPreviewImage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      Dentacareuser.dentacareimage &&
      typeof Dentacareuser.dentacareimage === "string"
    ) {
      setPreviewImage(Dentacareuser.dentacareimage);
    }
  }, [Dentacareuser.dentacareimage]);

  // Handle image change
  const handleImageChange = (e) => {
    const file = e.target.files[0];
  
    if (file) {
      const allowedTypes = ["image/jpg", "image/jpeg", "image/png", "image/webp"];
      const maxSize = 2 * 1024 * 1024; // 2MB
  
      // ✅ Type check
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        return;
      }
  
      // ✅ Size check
      if (file.size > maxSize) {
        toast.error("Image size should be under 2MB.");
        return;
      }
  
      // ✅ Optional: Dimension check (example: max 1920x1080)
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
  
      img.onload = () => {
        const { width, height } = img;
  
        // Example check (adjust if needed)
        if (width > 1000 || height > 1080) {
          toast.error("Image dimensions should not exceed 1000x1080.");
          URL.revokeObjectURL(objectUrl); // Clean up
          return;
        }
  
        setSelectedImage(file);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
        };
        reader.readAsDataURL(file);
      };
    }
  };

  useEffect(() => {
    const editData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getonedentacareimage/${id}`
        );
        setDentacareUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    editData();
  }, [id]);

  // Submit form
  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    if (selectedImage) {
      formData.append("dentacareimage", selectedImage);
    }

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updatedentacareimage/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        toast.success("Data updated successfully!");
        navigate("/Dentacare");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating the Dentacare:", error);
      toast.error("Failed to update Dentacare.");
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm} encType="multipart/form-data">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit</h5>
              <Link to="/Dentacare">
                <button type="button" className="close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Image</label>
                <input
                  type="file"
                  className="form-control"
                  name="dentacareimage"
                  onChange={handleImageChange}
                  accept="image/*"
                />
                <br />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "300px",
                    }}
                  />
                )}
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/Dentacare">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export const HomeDentacareTopEdit = () => {
  const [Dentacareuser, setDentacareUser] = useState({
    heading: "",
    description: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();
  const [editorLoaded, setEditorLoaded] = useState(false);

  // Load CKEditor
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.ckeditor.com/4.21.0/standard/ckeditor.js";
    script.async = true;
    script.onload = () => setEditorLoaded(true);
    document.body.appendChild(script);

    return () => {
      if (window.CKEDITOR) {
        Object.keys(window.CKEDITOR.instances).forEach((instance) =>
          window.CKEDITOR.instances[instance].destroy(true)
        );
      }
    };
  }, []);

  // Fetch existing data
  const fetchDentacareData = async () => {
    try {
      const response = await axios.get(
        `https://admin.gosaviadvanceddentalclinic.com/api/getonedentacaretop/${id}`
      );
      if (response.data.success) {
        setDentacareUser(response.data.data);
        if (window.CKEDITOR && window.CKEDITOR.instances.editor) {
          window.CKEDITOR.instances.editor.setData(
            response.data.data.description
          );
        }
      }
    } catch (error) {
      console.error("Error fetching Dentacare data!", error);
      toast.error("Failed to load Dentacare data.");
    }
  };

  useEffect(() => {
    if (editorLoaded) fetchDentacareData();
  }, [id, editorLoaded]);

  useEffect(() => {
    if (editorLoaded && !window.CKEDITOR.instances.editor) {
      window.CKEDITOR.replace("editor");
    }
  }, [editorLoaded]);

  useEffect(() => {
    if (editorLoaded && window.CKEDITOR.instances.editor) {
      window.CKEDITOR.instances.editor.setData(Dentacareuser.description || "");
    }
  }, [Dentacareuser.description, editorLoaded]);

  // Handle input change
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setDentacareUser({ ...Dentacareuser, [name]: value });
  };

  // Submit form
  const submitForm = async (e) => {
    e.preventDefault();

    const updatedData = {
      heading: Dentacareuser.heading,
      description: window.CKEDITOR.instances.editor.getData()
    };

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updatedentacaretop/${id}`,
        updatedData,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        toast.success("Data updated successfully!");
        navigate("/Dentacare");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating the Dentacare:", error);
      toast.error("Failed to update Dentacare.");
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm} encType="multipart/form-data">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit</h5>
              <Link to="/Dentacare">
                <button type="button" className="close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Heading</label>
                <input
                  type="text"
                  value={Dentacareuser.heading}
                  onChange={changeHandler}
                  className="form-control"
                  name="heading"
                  required
                />
                <br />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea id="editor"></textarea>
                <br />
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/Dentacare">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
